// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"_2xulfFb1Y0E9yVYf6TXmPx","success":"_17tyFMtHBo3NiFm67CHyd1","error":"_2G-OLlePVO9Jmth2mjm_K3"};